import { Paths } from "./../constants/UrlConstants";
import MemberHelper from "./MemberHelper";
import Store from "../content/Store";

export const ApplicationStatus = "Application";

export default class AddressHelper {
  static getAddressAsStringArray = function (address, isFormat2) {
    let addressArray = [];
    let newAddress = {
      ...address
    };
    if (address) {
      if (isFormat2) {
        newAddress["Line1"] = "";
      }

      addressArray = Object.keys(newAddress).map((addressLine) => {
        if (newAddress[addressLine]) {
          return newAddress[addressLine];
        }
        return undefined;
      });
    }
    return addressArray.filter((e) => e !== undefined);
  };

  static getAddressAsNewLineString = function (address, isFormat2) {
    let addressArray = AddressHelper.getAddressAsStringArray(
      address,
      isFormat2
    );
    return addressArray.join("\n");
  };

  static getChangeAddressLink = function (policy) {
    if (!policy) {
      return null;
    }
    let member = MemberHelper.getCurrentLoggedInMemberFromPolicy(policy);
    if (
      policy.IsSaga ||
      policy.IsInternational ||
      policy.IsLapsed ||
      (policy.IsFrozenPolicy && !policy.IsHealthSelect) ||
      policy.Status === ApplicationStatus ||
      !member.IsPolicyHolder
    ) {
      return null;
    } else if (!policy.IsFormat2 || policy.IsHealthSelect) {
      return Store.MyProfile.MemberAddress.LinkToFormat1;
    } else {
      return Paths.ChangeAddress;
    }
  };
}
